<template>
  <div ref="reportContainer" style="height: calc(100vh - 63px); width: 100%"></div>
</template>

<script>
import * as PowerBIClient from 'powerbi-client';

export default {
  name: 'PowerBIReportDisplay',
  props: {
    reportToken: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isEmbedded: false
    };
  },
  watch: {
    isActive(newValue) {
      if (newValue) {
        this.embedOrResize();
      }
    }
  },
  mounted() {
    if (this.isActive) {
      this.embedOrResize();
    }
  },
  beforeDestroy() {
    const el = this.$refs.reportContainer;
    if (el && window.powerbi) {
      window.powerbi.reset(el);
    }
  },
  methods: {
    buildEmbedConfig(token) {
      return {
        type: 'report',
        id: token.embedReportId,
        embedUrl: token.embedUrl,
        accessToken: token.accessToken,
        permissions: PowerBIClient.models.All,
        tokenType: PowerBIClient.models.TokenType.Embed,
        viewMode: PowerBIClient.models.ViewMode.View,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true
        }
      };
    },
    embedOrResize() {
      const el = this.$refs.reportContainer;
      if (!el || !window.powerbi || !this.reportToken) return;

      if (!this.isEmbedded) {
        window.powerbi.reset(el);
        window.powerbi.embed(el, this.buildEmbedConfig(this.reportToken));
        this.isEmbedded = true;
        return;
      }

      const report = window.powerbi.get(el);
      if (report && report.resize) {
        report.resize();
      }
    }
  }
};
</script>
